import { useEffect, useState } from "react"
import { AnimatePresence, motion } from "framer-motion"
import { Edit2, Trash2, X } from "lucide-react"
import styled from "styled-components"
import { useNavigate } from "react-router-dom"
import { API } from "../FormEdit"
import toast from "react-hot-toast"
import {
  TableContainer,
  TableHeader,
  TableTitle,
  AddButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  ResponsiveTableWrapper,
} from "./styled/Table"

// Reutilizamos los estilos del modal del ProductTable
const ModalContent = styled(motion.div)`
  background-color: #2A2B2E;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
`

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`

const ModalTitle = styled.h2`
  color: #FFFFFF;
  margin: 0;
`

const ModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`

const Button = styled.button`
  padding: 12px 20px;
  border-radius: 4px;
  border: none;
  background-color: #4A88F3;
  color: white;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #3B78E0;
  }

  &:disabled {
    background-color: #4A4B4F;
    cursor: not-allowed;
  }
`

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 1.5rem;
`

export const ScooterTable = ({ products }) => {
  const [scooters, setScooters] = useState([])
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [deleteScooter, setDeleteScooter] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    if (products) {
      setScooters(products.filter(product => product.isScooter))
    }
  }, [products])

  const tableVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  }

  const rowVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 100 },
    },
    hover: { scale: 1.01 },
  }

  const handleEdit = (scooter) => {
    navigate(`/administracion/edit-scooter/${scooter.id}`)
  }

  const handleDelete = (scooterId) => {
    setDeleteScooter(scooterId)
    setIsDeleteModalOpen(true)
  }

  const confirmDelete = () => {
    fetch(`${API}/api/productos/${deleteScooter}`, {
      method: 'DELETE'
    }).then(res => res.json())
    .then(data => {
      setScooters(scooters.filter(scooter => scooter.id !== deleteScooter))
      setIsDeleteModalOpen(false)
      toast.success('Scooter eliminada con éxito')
    })
    .catch(err => {
      toast.error('Error al eliminar la scooter')
    })
  }

  return (
    <>
      <TableContainer initial="hidden" animate="visible" variants={tableVariants}>
        <TableHeader>
          <TableTitle>Scooters</TableTitle>
          <AddButton 
            whileHover={{ scale: 1.05 }} 
            whileTap={{ scale: 0.95 }} 
            onClick={() => navigate("/administracion/create-scooter")}
          >
            Agregar Scooter
          </AddButton>
        </TableHeader>
        <ResponsiveTableWrapper>
          <Table>
            <TableHead>
              <tr>
                <TableCell as="th">IMAGEN</TableCell>
                <TableCell as="th">NOMBRE</TableCell>
                <TableCell as="th">SKU</TableCell>
                <TableCell as="th">ESTADO</TableCell>
                <TableCell as="th">PRECIO</TableCell>
                <TableCell as="th">POTENCIA</TableCell>
                <TableCell as="th">AUTONOMÍA</TableCell>
                <TableCell as="th">VEL. MAX</TableCell>
                <TableCell as="th">ACCIONES</TableCell>
              </tr>
            </TableHead>
            <TableBody>
              <AnimatePresence>
                {scooters?.map((scooter) => {
                     const images = typeof scooter?.img === "string" ? JSON.parse(scooter?.img) : scooter?.img;
                    const imageUrl = (() => {
                    if (!Array.isArray(images) || images.length === 0) return null;

                    const primary = images.find(img => img?.isPrimary === "true");
                    return (primary?.url?.secure_url || images[0]?.url?.secure_url || null);
                    })();

                 
                  return (
                    <TableRow 
                      key={scooter.id} 
                      variants={rowVariants} 
                      whileHover="hover" 
                      layout
                    >
                      <TableCell data-label="Imagen">
                        <img 
                          src={imageUrl && imageUrl} 
                          alt={scooter?.nombre} 
                          style={{ width: 40, height: 40, borderRadius: 4 }} 
                        />
                      </TableCell>
                      <TableCell data-label="Nombre">{scooter?.nombre}</TableCell>
                      <TableCell data-label="SKU">{scooter?.sku}</TableCell>
                      <TableCell data-label="Estado">{scooter?.status === 0 ? "Activo" : "Inactivo"}</TableCell>
                      <TableCell data-label="Precio">
                        {new Intl.NumberFormat("es-CO", {
                          style: "currency",
                          currency: "COP",
                        }).format(scooter?.precio)}
                      </TableCell>
                      <TableCell data-label="Potencia">{scooter?.motor_power}</TableCell>
                      <TableCell data-label="Autonomía">{scooter?.range}</TableCell>
                      <TableCell data-label="Velocidad Máx.">{scooter?.max_speed}</TableCell>
                      <TableCell data-label="Acciones">
                        <div style={{ display: "flex", gap: "8px" }}>
                          <button
                            onClick={() => handleEdit(scooter)}
                            style={{ background: "none", border: "none", cursor: "pointer" }}
                          >
                            <Edit2 size={18} color="#4A88F3" />
                          </button>
                          <button
                            onClick={() => handleDelete(scooter?.id)}
                            style={{ background: "none", border: "none", cursor: "pointer" }}
                          >
                            <Trash2 size={18} color="#FF4444" />
                          </button>
                        </div>
                      </TableCell>
                    </TableRow>
                  )
                })}
              </AnimatePresence>
            </TableBody>
          </Table>
        </ResponsiveTableWrapper>
      </TableContainer>

      {isDeleteModalOpen && (
        <ModalOverlay initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
          <ModalContent
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
          >
            <ModalHeader>
              <ModalTitle>Confirmar Eliminación</ModalTitle>
              <CloseButton onClick={() => setIsDeleteModalOpen(false)}>
                <X size={24} />
              </CloseButton>
            </ModalHeader>
            <p style={{ color: "#FFFFFF", marginBottom: "20px" }}>
              ¿Estás seguro de que quieres eliminar esta Scooter?
            </p>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
              <Button onClick={() => setIsDeleteModalOpen(false)}>Cancelar</Button>
              <Button onClick={confirmDelete} style={{ backgroundColor: "#FF4444" }}>
                Eliminar
              </Button>
            </div>
          </ModalContent>
        </ModalOverlay>
      )}
    </>
  )
}
